import { adsReducer, actions as adActions } from './Ads'
import { clockReducer, actions as clockActions } from './Clock'
import { newsReducer, actions as newsActions } from './News'
import { backendReducer, actions as backendActions } from './Backend'
import { settingsReducer, middleware as SettingsMiddleware } from './Settings'
import { toasterReducer, middleware as ToasterMiddleware } from './Toaster'
import {
    loadingBarReducer,
    actions as loadingBarActions,
    middleware as LoadingBarMiddleware,
} from './LoadingBar'

export const featureActions = {
    languageChanged: locale => (dispatch) => {
        dispatch(adActions.languageChanged(locale))
        dispatch(clockActions.languageChanged(locale))
        dispatch(newsActions.languageChanged(locale))
        dispatch(backendActions.languageChanged(locale))
        dispatch(loadingBarActions.languageChanged(locale))
    },

    steamChanged: isSteam => (dispatch) => {
        dispatch(adActions.steamChanged(isSteam))
        dispatch(loadingBarActions.steamChanged(isSteam))
    },
}

export const featureReducers = {
    adsReducer,
    clockReducer,
    newsReducer,
    settingsReducer,
    backendReducer,
    toasterReducer,
    loadingBarReducer,
}

export const featureMiddlewares = [SettingsMiddleware, ToasterMiddleware, LoadingBarMiddleware]



// WEBPACK FOOTER //
// ./src/features/index.js